export default "__VITE_ASSET__ef18184c__"